import { createApp } from "vue";
import "@bhplugin/vue3-datatable/dist/style.css";
import App from "./App.vue";
import "./registerServiceWorker";
import { createPinia } from "pinia";
import modal from "@/plugins/modal";
import router from "./router";

import { VueSpinnersPlugin } from "vue3-spinners";
import "./plugins/validation.js";

import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

import "@/assets/main.css";

const app = createApp(App);
const pinia = createPinia();

app.use(VueSpinnersPlugin);
app.use(modal);

app.use(Vue3Toastify)

app.use(pinia);
app.use(router);

app.mount("#app");
